// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2CB9h","text":"SelectPayment_text__ImCOn","title":"SelectPayment_title__299sK","btn":"SelectPayment_btn__SzqSh"};